import React, { useEffect} from 'react';

import {rootActions, useAppDispatch, useAppSelector} from "../../../products/product-page/data-services/store";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";
import {
    getMenuSelected
} from "../data-services/data-service";
import {getHashByPrefix} from '../../../../domain/common';
import CarouselRightArrowIcon from "../../../../ui/svg/common/carousel-right-arrow";
import YotpoPreview from "../../../yotpo-preview/yotpoPreview";
import {downloadJSAtOnload} from "../../../../domain/defer-script";
/**
 * the entry point
 */
const StickyMenu: React.FC = () => {

    // test -----------
    const dispatch = useAppDispatch();
    const isDebug = useAppSelector((store) => store.isDebug);
    const menuStickyList = useAppSelector((store) => store.menuStickyList);
    const menuStickySelected = useAppSelector((store) => store.menuStickySelected);
    const hash = useAppSelector((store) => store.hash);
    const newHash = useAppSelector((store) => store.newHash);
    const techSpecsRefreshHash = useAppSelector((store) => store.techSpecsRefreshHash);


    let urlHash=hash.toString();
    let urlHashSaved='';

    useEffect(() => {
        window.addEventListener("hashchange", checkHashLogic);
        tabSelect(hash);
    }, [urlHash]);

    const getHash = () => {
        //return window.location.hash.substring(1);
        return getHashByPrefix('tab-');
    }
        const checkHashLogic = () => {

        //console.log(`window.location.hash: ${window.location.hash}`);
        const currentHash  = getHash();

        //console.log(`1. cur: ${getHash()} , hash: ${hash} , newHash: ${newHash} , urlHash: ${urlHash} , saved:${urlHashSaved}`);

        if(currentHash === urlHash){
            if(urlHashSaved !== '') {/*if urlHashSaved not empty => changed by code and go(-1)*/
                hashChangedByUrl();
            }
            else{
                hashChangedByCode();
            }
        }
        else {
            //console.log('hash changed in url. step 1');
            if(urlHashSaved === '')
            {
                //console.log('hash changed in url. urlHashSaved === ');
                urlHashSaved = currentHash;
                window.setTimeout(() => {
                    window.history.go(-1);
                }, 10);
            }

        }
    }
    const hashChangedByUrl = () => {
        //console.log(`hash changed in url. step 2`);
        //console.log('-----------------------',urlHashSaved);
        const _savedHash = urlHashSaved.toString();
        urlHash = _savedHash;
        urlHashSaved = '';
        window.setTimeout(() => {
            window.history.replaceState(null, '', document.location.pathname+ document.location.search + "#" + _savedHash);
            menuSelect(_savedHash);
            hashChangedFinilize();
        }, 0);
    }
    const hashChangedByCode = () => {
        //console.log('hash changed by code.');
        hashChangedFinilize();
    }
    const hashChangedFinilize = () => {

        //console.log(`-------------------------------hashChangedFinilize: getHashExcludePrefix: ${getHashExcludePrefix('tab-')}`);
        //console.log(`-------------------------------hashChangedFinilize: cur: ${window.location.hash.substring(1)} , hash: ${hash} , newHash: ${newHash} , urlHash: ${urlHash} , saved:${urlHashSaved}`);
    }
    const changeHashByUrl= (newHash:string) => {
        //console.log(`changeHashByUrl: `, `#tab-${newHash}`);
        window.location.hash = `#tab-${newHash}`;
    }
    const changeHashByCode= (newHash:string) => {
        //console.log(`changeHashByCode:urlCurrentHash:${urlCurrentHash} `, newHash);
        urlHash = newHash.toString();
        dispatch(
            rootActions.main({
                newHash:newHash
            })
        );
        urlHashSaved = getHash();
        window.setTimeout(() => {
            hashChangedFinilize();
            window.history.replaceState({saved:getHash()}, '', document.location.pathname + "#" + newHash);
        }, 0);

    }
    window.onpopstate = function (e) {
        //console.log('onpopstate: ',e.state);
        if (typeof e.state == "object" && e.state != null && e.state.saved != null) {
            //console.log(e.state);
            window.history.replaceState({}, '', document.location.pathname + "#" + e.state.saved);
        }
    };
    /**
     * select menu item
     */
    const menuSelect = (newHash:string) => {
        tabSelect(newHash);
        const _menuSelected = getMenuSelected(newHash, menuStickyList);

        if(newHash === 'tab-tech-specs'){
            console.log('menuSelect: => true ',newHash);
            dispatch(
                rootActions.main({
                    techSpecsRefreshHash:true
                })
            );
        }

        dispatch(
            rootActions.main({
                menuStickySelected:_menuSelected
                , newHash:newHash
            })
        );

        //stopAllYouTubeVideos();
    };
    /**
     * select menu tab
     */
    const tabSelect = (newHash:string) => {
        if(!newHash || newHash === '')
            return;


        const tabDiv:any = document.getElementById(newHash);
        if(!tabDiv)
            return;
        //console.log(`tabSelect: `, newHash);
        if(newHash === 'tab-reviews'){
            //console.log('tab-reviews: => true ',newHash);
            YotpoPreview.Init();
        }

        if(newHash === 'tab-chains') {
            //console.log('tab-chains: => true ',newHash);
            const productPresetsMinPath = (document.getElementById('product-presets-min')?.textContent || '')?.trim().toLowerCase() ;
            if(productPresetsMinPath !== ''){
                downloadJSAtOnload(productPresetsMinPath);
                }
        }

        const tabDiv_All: any = document.getElementsByClassName("tabs");
        for (let tab of tabDiv_All) {
            if( tab.style.display !== 'none')
                tab.style.display = 'none';
        }

        tabDiv.style.display = 'block';
        const _videoHash = getHashByPrefix('video-');
        if(!_videoHash)
            tabDiv.scrollIntoView();
    };



    return (
                <>
                    {isDebug &&
                        <div className="">
                            <div className="flex flrx-row"><div className="w-24"
                                                                onClick={evt => {
                                                                    dispatch(
                                                                        rootActions.main({
                                                                            techSpecsRefreshHash:true
                                                                        })
                                                                    );
                                                                }}
                            >RefreshHash:</div>{techSpecsRefreshHash.toString()}</div>
                            <div className="flex flrx-row"><div className="w-24">currentHash:</div>{window.location.hash.substring(1)}</div>
                            <div className="flex flrx-row"><div className="w-24">urlHash:</div>{urlHash}</div>
                            <div className="flex flrx-row"><div className="w-24">hash:</div>{hash}</div>
                            <div className="flex flrx-row"><div className="w-24">newHash:</div>{newHash}</div>
                            <div className="flex flrx-row"><div className="w-24">savedHash:</div>{urlHashSaved}</div>
                            <div className="flex flrx-row">
                                <button className="w-32 bg-gray-500 text-white"
                                    onClick={evt => {
                                        changeHashByCode("_1");
                                        //menuSelect(menu);
                                    }}
                                >ChangeCache _1:</button></div>
                        </div>
                    }

                    <div className="arr-left py-1 flex items-center h-full z-50" style={{display:'none'}}>
                        <div className="py-2 bg-gray-100 flex justify-center items-center h-full w-full">&lt;</div>
                    </div>
                    <ul className="carousel-slides flex flex-wrap justify-center" data-carusel="mobile" style={{transform: 'translateX(0px)'}} >

                    {menuStickyList.map(menu => {
                        return (
                            <li key={menu.name}
                                  id={menu.id}
                                 className={`carousel-row w-fit py-5 px-4 text-sm lg:text-base text-gray-700 flex items-center justify-center text-center cursor-pointer mr-2  ${menu === menuStickySelected ? 'selected' : ''}`}>
                                <button type="button"
                                        onClick={evt => {
                                            sendGAEvent('Tabs', menu.name);
                                            changeHashByUrl(menu.id);
                                            //menuSelect(menu);
                                    }}>
                                    {menu.name}
                                </button>
                            </li>
                        )
                    })}
                    </ul>
                    <div className="arr-right py-1 flex justify-center items-center h-full z-50" style={{display:'none'}}>
                        <div className="arr-bg py-2  flex justify-center items-center h-full w-full"><CarouselRightArrowIcon width="10px" /></div>
                    </div>
                </>
    )
};

export default StickyMenu;